import { NgModule } from '@angular/core';
import { SortArrayPipe } from './sort-array.pipe';
/**
 * A module containing objects associated with the sort array pipe
 */
var SortArrayPipeModule = /** @class */ (function () {
    function SortArrayPipeModule() {
    }
    SortArrayPipeModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        SortArrayPipe
                    ],
                    exports: [
                        SortArrayPipe
                    ]
                },] },
    ];
    /** @nocollapse */
    SortArrayPipeModule.ctorParameters = function () { return []; };
    return SortArrayPipeModule;
}());
export { SortArrayPipeModule };
//# sourceMappingURL=sort-array.pipe.module.js.map